import { render } from "./signUp2.vue?vue&type=template&id=76e5ba5c"
import script from "./signUp2.vue?vue&type=script&lang=js"
export * from "./signUp2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__